import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  // White-to-transparent fade so the arrow reads as "more below". Sits above
  // the list, ignores pointer events so the list stays scrollable underneath.
  fade: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 48,
    background: `linear-gradient(to top, ${C.cardBg}, transparent)`,
    pointerEvents: 'none',
  },
  button: {
    position: 'absolute',
    // Center without a transform so the bounce keyframe owns `transform`.
    left: 'calc(50% - 16px)',
    bottom: 4,
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: C.scrollHintBg,
    border: `1px solid ${C.scrollHintBorder}`,
    boxShadow: '0px 2px 6px 0px rgba(15,23,42,0.12)',
    color: C.darkText,
    cursor: 'pointer',
    padding: 0,
  },
}))
